import Cookies from 'js-cookie'

import { Consent } from '../../../../api/AccountConsent/getAccountConsents'

export const isToBeRequested = (consent: Consent): boolean => consent.status === 'ToBeRequested'

export const getConsentCookie = (consentId: string, accountId: string): number | undefined => {
  const cookieDoesNotExists = !Cookies.get(`AccountConsent-${accountId}-${consentId}`)
  if (cookieDoesNotExists) return undefined

  return Number(Cookies.get(`AccountConsent-${accountId}-${consentId}`))
}

export const shouldWriteConsentCookie = (consentId: string, accountId: string): boolean =>
  !getConsentCookie(consentId, accountId)

export const consentCookieIsExpired = (consentId: string, accountId: string): boolean =>
  Number(Cookies.get(`AccountConsent-${accountId}-${consentId}`)) <= new Date().getTime()

export const writeConsentCookie = (consentId: string, accountId: string): void => {
  Cookies.set(`AccountConsent-${accountId}-${consentId}`, String(new Date().getTime()))
}

export const writeToBeRequestedConsentThatHaveNoCookie = (consent: Consent, accountId: string): void => {
  if (isToBeRequested(consent)) {
    if (shouldWriteConsentCookie(consent.id, accountId)) {
      writeConsentCookie(consent.id, accountId)
    }
  }
}
